import { format } from 'date-fns';
import { da } from 'date-fns/locale';
import { isHoliday } from './calculate-holiday';

export function getNextOpenBusinessDay(date: Date): string {
    let isNextOpenDayFound = false;
    let isNextOpenDayTomorrow = true;
    let isDateAHoliday: boolean;
    let isDateAWeekend: boolean;
    let checkDate = new Date();

    checkDate.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
    checkDate.setDate(checkDate.getDate() + 1);

    while (!isNextOpenDayFound) {
        isDateAHoliday = isHoliday(checkDate);
        isDateAWeekend = isWeekend(checkDate.getDay());

        if (!isDateAHoliday && !isDateAWeekend) {
            return getResultString(isNextOpenDayTomorrow, checkDate);
        } else {
            checkDate.setDate(checkDate.getDate() + 1);
            isNextOpenDayTomorrow = false;
        }
    }

    throw new Error('A next open business day should always be found.');
}

function getResultString(isNextOpenDayTomorrow: boolean, date: Date): string {
    const MONDAY = 1;
    const MONDAY_RESULT = 'mon';
    const TOMORROW_RESULT = 'tomorrow';

    if (isNextOpenDayTomorrow) {
        return TOMORROW_RESULT;
    } else if (date.getDay() === MONDAY) {
        return MONDAY_RESULT;
    } else {
        return formatDate(date);
    }
}

function isWeekend(day: number): boolean {
    const SUNDAY = 0;
    const SATURDAY = 6;
    return day === SUNDAY || day === SATURDAY;
}

function formatDate(date: Date) {
    return format(date, "EEEE 'den' d. MMMM", { locale: da });
}
